export default __webpack_public_path__ + "static/media/green_tick_round.6058504d.svg";